export const CATALOG_KEY = 'chp-chimichangas-catalog-v1';
export const categories = ['Stickers', 'Libros y PDF', 'Contadores', 'Diseño y edición', 'Lechuzas', 'Astrología', 'Audio y música', 'Especiales', 'Chimichangas'];

const rows = [
  [
    "Paquete de 30 stickers con movimiento y GIF sin fondo",
    3000,
    "",
    "Stickers"
  ],
  [
    "Sagas de más de 5 libros",
    3000,
    "",
    "Libros y PDF"
  ],
  [
    "Contador del club de lectura por día",
    2000,
    "",
    "Contadores"
  ],
  [
    "Contador de participaciones por día",
    1500,
    "",
    "Contadores"
  ],
  [
    "Pack de 30 stickers",
    1500,
    "",
    "Stickers"
  ],
  [
    "Editor de video",
    1500,
    "",
    "Diseño y edición"
  ],
  [
    "Sagas completas de 3 libros",
    1000,
    "",
    "Libros y PDF"
  ],
  [
    "Contador de puntos por dinámica",
    1000,
    "",
    "Contadores"
  ],
  [
    "Buscador de letras de karaoke",
    1000,
    "",
    "Audio y música"
  ],
  [
    "Editor de imágenes",
    1000,
    "",
    "Diseño y edición"
  ],
  [
    "Lechuza multipropósitos premium",
    1000,
    "",
    "Lechuzas",
    "Carta o mensaje editado en video. Puede ser pública o anónima."
  ],
  [
    "Lectura extensa de carta astral",
    1000,
    "",
    "Astrología"
  ],
  [
    "El Quisquilloso: Edición secretos",
    200,
    "",
    "Especiales",
    "Opciones de 200, 400, 600 y 1,000 Sichples.",
    [
      200,
      400,
      600,
      1000
    ]
  ],
  [
    "Saga de Harry Potter",
    500,
    "",
    "Libros y PDF"
  ],
  [
    "Pack de 10 stickers",
    500,
    "",
    "Stickers"
  ],
  [
    "Tarjetas para toda ocasión (animadas)",
    500,
    "",
    "Diseño y edición"
  ],
  [
    "Contador de Flash",
    500,
    "",
    "Contadores"
  ],
  [
    "Audios personalizados de la zorra",
    500,
    "",
    "Audio y música",
    "Motivacionales, felicitaciones y más."
  ],
  [
    "Lechuza multipropósitos personalizada",
    500,
    "",
    "Lechuzas",
    "Incluye carta y edición a gusto del solicitante. Puede ser pública o anónima."
  ],
  [
    "Lectura general de carta astral",
    500,
    "",
    "Astrología",
    "Sol, Luna y Ascendente."
  ],
  [
    "Canciones en MP3 / audio de canciones",
    500,
    "",
    "Audio y música"
  ],
  [
    "Tarjetas para toda ocasión",
    300,
    "",
    "Diseño y edición"
  ],
  [
    "Lechuza multipropósitos básica",
    300,
    "",
    "Lechuzas",
    "Incluye carta decorada. Puede ser pública o anónima."
  ],
  [
    "Novios, amigos y elfos",
    250,
    "",
    "Especiales"
  ],
  [
    "PDF: Hogwarts, una guía incompleta y poco fiable",
    200,
    "",
    "Libros y PDF"
  ],
  [
    "PDF: Historias breves de Hogwarts, Agallas, Adversidad y Aficiones Arriesgadas",
    200,
    "",
    "Libros y PDF"
  ],
  [
    "PDF: Historias breves de Hogwarts, Poder, Política y Poltergeist Pesado",
    200,
    "",
    "Libros y PDF"
  ],
  [
    "PDF: Animales fantásticos y dónde encontrarlos",
    200,
    "",
    "Libros y PDF",
    "Con anotaciones de Harry, Hermione y Ron. Se entrega junto con el guion."
  ],
  [
    "PDF: Harry Potter, los especiales",
    200,
    "",
    "Libros y PDF"
  ],
  [
    "PDF: Harry Potter y el legado maldito",
    200,
    "",
    "Libros y PDF"
  ],
  [
    "Fondos de pantalla o de chat",
    150,
    "",
    "Diseño y edición"
  ],
  [
    "Sticker con movimiento",
    150,
    "",
    "Stickers"
  ],
  [
    "Sticker",
    120,
    "",
    "Stickers"
  ],
  [
    "Cartel de Indeseable N.º 1",
    120,
    "",
    "Diseño y edición"
  ],
  [
    "PDFs",
    100,
    "",
    "Libros y PDF"
  ],
  [
    "Cartas de Lotería",
    100,
    "",
    "Especiales"
  ],
  [
    "Boleto de Sorteo",
    100,
    "",
    "Especiales"
  ],
  [
    "Cartel de «Have You Seen This Wizard?»",
    100,
    "",
    "Diseño y edición"
  ],
  [
    "Foto con marco de Harry Potter",
    100,
    "",
    "Diseño y edición",
    "Con una lechuza, libro de hechizos o ambos. Precio por cada uno."
  ],
  [
    "Cartas de Hogwarts en inglés",
    80,
    "",
    "Diseño y edición"
  ],
  [
    "Nombre en Mapa del Merodeador",
    80,
    "",
    "Diseño y edición"
  ],
  [
    "Nombre en caligrafía temática",
    70,
    "",
    "Diseño y edición",
    "Shrek, Iron Maiden, Star Wars, Bandera LGBT+, Matrix, Minions, Avengers, Disney, BlackPink, Pokémon, Angry Birds o Marvel Studios. Precio por cada uno."
  ],
  [
    "Nombre en arena, nieve, vidrio empañado o letrero",
    70,
    "",
    "Diseño y edición",
    "Precio por cada uno."
  ],
  [
    "Chimichangas",
    20,
    "",
    "Chimichangas"
  ],
  [
    "Pase por un día",
    5000,
    "",
    "Especiales"
  ]
];
export const initialProducts = rows.map(([name,price,owners,category,description='',prices],index)=>({id:`chimi-${String(index+1).padStart(3,'0')}`,name,description,category,prices:prices||[price],owners:owners?owners.split(', '):[],active:true}));

export function validateProducts(value) {
  if(!Array.isArray(value)||value.length>1000)throw Error('El archivo debe contener hasta 1,000 productos.');
  const ids=new Set();
  return value.map(item=>{
    if(!item||typeof item.id!=='string'||!item.id||item.id.length>80||ids.has(item.id))throw Error('Hay identificadores de producto inválidos o repetidos.');
    ids.add(item.id);
    if(typeof item.name!=='string'||!item.name.trim()||item.name.length>200||typeof item.description!=='string'||item.description.length>1500||!categories.includes(item.category)||typeof item.active!=='boolean')throw Error('Revisa los nombres, descripciones y categorías.');
    if(!Array.isArray(item.prices)||!item.prices.length||item.prices.length>12||item.prices.some(price=>!Number.isSafeInteger(price)||price<1||price>999999999))throw Error('Los precios deben ser enteros entre 1 y 999,999,999 Sichples.');
    if(!Array.isArray(item.owners)||item.owners.length>30||item.owners.some(name=>typeof name!=='string'||!name.trim()||name.length>80))throw Error('Revisa los nombres de los responsables.');
    return {id:item.id,name:item.name.trim(),description:item.description.trim(),category:item.category,prices:[...new Set(item.prices)].sort((a,b)=>a-b),owners:[...new Set(item.owners.map(name=>name.trim()))],active:item.active};
  });
}

export function readCatalog() {
  try {
    const raw=localStorage.getItem(CATALOG_KEY);
    if(!raw)return {products:initialProducts,warning:''};
    const data=JSON.parse(raw);
    if(data.version!==1)throw Error('Versión no reconocida.');
    return {products:validateProducts(data.products),warning:''};
  }catch{return {products:initialProducts,warning:'No se pudo leer el catálogo guardado. Se muestra el catálogo inicial; revisa el almacenamiento del navegador antes de guardar cambios.'};}
}

export const priceLabel = product => product.prices.map(value=>new Intl.NumberFormat('es-GT').format(value)).join(' / ');
export const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
